import { useMutation, useQueryClient } from '@tanstack/react-query'
import MilkingProcessService from 'services/milkingProcessService'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export const useDeleteMilkerMutation = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	return useMutation({
		mutationFn: ({ id }: { id: number | string; name: string }) =>
			MilkingProcessService.deleteMilker(id),
		onSuccess: (_, { name }) => {
			queryClient.invalidateQueries({ queryKey: ['milkers-info'] })
			dispatch(
				notifyUser({
					title: `Дояр ${name} удален`,
					description: '',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Попробуйте снова.',
					isError: true,
				}),
			)
		},
	})
}
